const underworld = require('sci/std/underworld')
const gql = require('graphql-tag')

module.exports = underworld.registerEventType(
    'task-created',
    gql`
            fragment TaskCreatedEvent on TaskCreatedEvent {
                id
            }
        `
);


// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/subscriptions/task-created.js